import {Col, Row} from "react-bootstrap";
import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {
  formatCurrency,
  handleDefaultValues,
} from "../../common/Utils";
import {useForm} from 'react-hook-form';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {
  getInventoryItem
} from "../../common/api/PortalCustomerApi";
import Meta from "../../common/Meta";
import {Card, CardContent, Divider, Grid} from "@mui/material";
import {addtoWaitlist} from "../../common/api/CartApi";
import CustomerPageLayout from "../../Layout/CustomerPageLayout";
import CustomerHeader from "../../common/CustomerHeader";
import MDBox from "../../../components/MDBox";
import Footer from "../../Footer";
import {CartContext} from "../../../lib/CartProvider";
import {UserContext} from "../../../lib/UserProvider";
import {CompanyContext} from "../../../lib/CompanyProvider";
import MDButton from "../../../components/MDButton";
import ViewInventoryModal from "../modal/ViewInventoryModal";
import Avatar from "@mui/material/Avatar";
import Link from "@mui/material/Link";
import {AllInclusive, People, RefreshOutlined, RemoveCircle} from "@mui/icons-material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MembershipPerks from "../perks/MembershipPerks";

export default function CustomerViewInventory(props) {
  const navigate = useNavigate();
  const [context, setContext] = useContext(AppContext);
  const [cartContext, setCartContext] = useContext(CartContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [userContext, setUserContext] = useContext(UserContext);

  const [company, setCompany] = useState(companyContext?.company);
  const location = useLocation();
  let {inventoryId} = useParams();
  const [eventReady, setEventReady] = useState(false);
  const [event, setEvent] = useState();
  const [inventory, setInventory] = useState();

  const onAccountChange = (props) => {
  }
  const [pageReady, setPageReady] = useState(false);
  useEffect(() => {
    if (companyContext?.company?.guid) {
      setPageReady(true);
      setCompany(companyContext?.company);
    }
  }, [companyContext?.company]);

  useEffect(() => {
    if (!pageReady) {
      return;
    }
    getInventoryEventFn();
  }, [pageReady, inventoryId]);

  const [isMembership, setIsMembership] = useState(false);

  useEffect(()=> {
    setIsMembership(inventory?.inventoryMembership);
  }, [inventory]);

  const getInventoryEventFn = async () => {
    getInventoryItem(inventoryId).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventory(result);
        setEventReady(true);
      }
    });
  }

  const [inventoryType, setInventoryType] = useState();
  const [formInvalid, setFormInvalid] = useState(false);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventoryType)
  });

  const handleClose = () => {
    if (props.handleSave) {
      props.handleSave();
    }
  };

  const handleSave = (data) => {
    props.handleSave(data);
  };

  const viewEvent = (e) => {
    navigate('/cx/register/' + e.guid);
  };

  const [showInventoryModal, setShowInventoryModal] = useState(false);

  const addToWaitlistFn = async (e) => {
    if (!context?.sessionUser?.guid) {
      setUserContext({...userContext, showLogin: true});
      return;
    }
    addtoWaitlist(event).then(resp => {
      handleClose();

      setCartContext({...cartContext, reloadCart: true});

      let _context = {...context};
      _context.toast = {
        message: 'Added to Event Wait List!',
      }
      setContext({..._context});
    });
  };


  return (

    <>
      <CustomerPageLayout>

        <CustomerHeader props={props}/>

        <Meta pageTitle={inventory?.name}/>

        <Grid container>
          <Grid item xs={12} sm={12}>
            <MDBox py={2}>
              {eventReady &&

                <MDBox py={2} m={1}>
                  <Card>
                    <CardContent>
                      <Grid container>
                        <Grid item sm={3}>
                          <Avatar alt={inventory?.name}
                                  variant="rounded"
                                  sx={{width: '80%', height: 'auto'}}>
                            {inventory?.imageUrl && <img src={inventory?.imageThumbUrl || inventory?.imageUrl}
                                                         style={{width: '100%', height: 'auto'}}
                                                         alt={inventory?.name}/>}
                          </Avatar>
                        </Grid>
                        <Grid item sm={9}>
                          <h4 style={{
                            display: 'block',
                          }}>
                            <Link href={"#/cx/view-item/" + inventory?.guid}>{inventory.name}</Link>
                          </h4>

                          <div style={{
                            display: 'block',
                          }}>
                            <Col className={'col'} lg={3} md={6} sm={12} xs={12}>
                              <p>
                                {inventory?.giftCard && <>
                                  <b>Value:</b>&nbsp;
                                  {inventory?.minAmount === inventory?.maxAmount ? <>{formatCurrency(inventory?.minAmount)}</> : <>
                                    {formatCurrency(inventory?.minAmount)} - {formatCurrency(inventory?.maxAmount)}</>}
                                </>}
                                {!inventory?.giftCard && <>
                                  <b>Price:</b>&nbsp;{formatCurrency(inventory.price)}
                                </>}
                              </p>
                            </Col>

                            <div>
                              <MDBox mt={1}>
                                {inventory?.accountType && <>
                                  <dl className={'row'}>
                                    {inventory?.accountType?.recurring &&
                                      <>
                                        <dd className={'col col-sm col-sm-12'}>
                                          <small><RefreshOutlined/> Recurring
                                            {inventory?.accountType?.recurrencePattern === 'TIME_BASED_RECURRING' && ' every ' +
                                              inventory?.accountType.membershipTimeDays + ' Days'}
                                          </small>
                                        </dd>
                                        {companyContext?.company?.preferences['hide_cancel_anytime'] !== 'true' && <>
                                          <dd className={'col col-sm col-sm-12'}>
                                            <small><RemoveCircle/> Cancel at any time</small>
                                          </dd>
                                        </>}
                                      </>
                                    }
                                    {inventory?.accountType?.unlimitedVisits &&
                                      <dd className={'col col-sm col-sm-12'}>
                                        <small><AllInclusive/> Unlimited Visits</small>
                                      </dd>
                                    }
                                    {inventory?.accountType?.timeBased &&
                                      <dd className={'col col-sm col-sm-12'}>
                                        <small><AccessTimeIcon/> Expires in
                                          Days {inventory?.accountType?.membershipTimeDays}</small>
                                      </dd>
                                    }

                                    {inventory?.siblingMembership && <>
                                      <dd className={'col col-sm col-sm-6'}>
                                        <small><People/> Sibling
                                          Rate {formatCurrency(inventory?.siblingMembership?.price)}
                                        </small>
                                      </dd>
                                    </>}
                                  </dl>

                                  <MembershipPerks inventory={inventory}/>

                                </>}

                                {inventory?.desc?.length > 0 && <>
                                  <h6>Details</h6>
                                  <div style={{
                                    clear: 'both',
                                    marginTop: '10px',
                                    whiteSpace: 'pre-wrap',
                                    fontSize: '0.875rem',
                                    marginBottom: '20px'
                                  }}>
                                    <p>
                                      {inventory?.desc}
                                    </p>
                                  </div>
                                </>
                                }
                              </MDBox>
                            </div>
                          </div>

                          <MDButton
                            size={'small'}
                            className={'my-2'}
                            color="secondary"
                            onClick={(e) => {
                              setShowInventoryModal(true)
                            }}>View Details</MDButton>

                        </Grid>

                      </Grid>

                    </CardContent>
                  </Card>
                </MDBox>
              }
            </MDBox>
          </Grid>
        </Grid>
        {
          inventory && <ViewInventoryModal
            key={inventory?.guid}
            membershipType={isMembership}
            handleClose={() => {
              setShowInventoryModal(false);
            }}
            handleSave={() => {

            }}
            show={showInventoryModal}
            inventory={inventory}
          />
        }
        <Footer/>
      </CustomerPageLayout>
    </>
  );
}